




import {Component, Prop} from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import BookingRoleStatus from '@/models/BookingRoles/BookingRoleStatus';
import StatusDisplayLocation from '@/models/Shared/StatusDisplayLocation';


@Component({
  name: 'BookingRoleStatus',
})
export default class extends GiganautVue {

	@Prop({required: true})
	status: BookingRoleStatus;

	@Prop({required: true})
	location: StatusDisplayLocation;
	
	get textColor() {
		let color = "grey--text";
		switch (this.status) {
			case BookingRoleStatus.Active:
				color = "green--text";
				break;
			case BookingRoleStatus.Cancelled:
				color = "red--text";
				break;
			default:
				color = "grey-text";
				break;
		}
		return color;
	}

	get text() {
		let text = "";
		switch (this.status) {
			case BookingRoleStatus.Active:
				text = "ACTIVE";
				break;
			case BookingRoleStatus.Cancelled:
				text = "CANCELLED";
				break;
			default:
				text = "UNKNOWN STATUS"
				break;
		}
		return text;
	}
	
	get classy() {
		const classes: string[] = [this.textColor]
		switch (this.location) {
			case StatusDisplayLocation.Title:
				classes.push("overline");
				classes.push("ma-2");
				break;
			case StatusDisplayLocation.SubTitle:
				classes.push("overline");
				classes.push("mr-2");
				break;
			case StatusDisplayLocation.SubTitle:
			default:
				classes.push("overline");
				classes.push("ma-2");
				break;
		}
		return classes;
	}
}
